import { CancelReason, CodeNext, FusionError, safeUnparseJson, serializeFusionError } from "@fusion-advantage/backcompat"
import { EncounterCodeNextUpdate, importDateNow } from "@fusion-advantage/formlib"
import { AppThunk } from "../redux/appStore"
import { selectWritesDisabled } from "../redux/selectWritesDisabled"
import { err, ok, Result } from "neverthrow"
import { dashboardDataReloadFromLdb, selectDashboardDisplayIdentity } from "../redux/dashboardDataSlice"
import { selectImportableLocation } from "../redux/locationSlice"
import { DeviceToCloudBlobType, insertDeviceToCloudBlob } from "../dal/ldbDeviceToCloudBlob"

export const updateEncounterStatus = (encounterGuid: string, nextCodeNext: CodeNext, cancelReason?: CancelReason): AppThunk<Promise<Result<void, FusionError>>> => async (dispatch, getState) => {
	if(selectWritesDisabled(getState())) {
		return ok()
	}
	const user = selectDashboardDisplayIdentity(getState())
	if(!user) {
		return err(serializeFusionError('updateEncounterStatus', 'no user identity available'))
	}
	const esBody: EncounterCodeNextUpdate = {
		SubmittingUserID: user.upn,
		...importDateNow(),
		Location: selectImportableLocation(getState()),
		EncounterGUID: encounterGuid,
		CodeNext: nextCodeNext,
	}
	if(cancelReason) {
		esBody.CancelReason = cancelReason
	}
	const rEsUnparse = safeUnparseJson(esBody)
	if(rEsUnparse.isErr()) {
		return err(serializeFusionError('updateEncounterStatus', rEsUnparse.error))
	}
	const rEsUpdate = await insertDeviceToCloudBlob({
		type: DeviceToCloudBlobType.EncounterStatus,
		encounterGuid,
		fileId: null,
		upn: user.upn,
		data: rEsUnparse.value,
		bin: false,
		nextCodeNext,
		contentType: null,
	})
	if(rEsUpdate.isErr()) {
		return err(serializeFusionError('updateEncounterStatus', rEsUpdate.error))
	}
	dispatch(dashboardDataReloadFromLdb())
	return ok()
}
